import { Routes } from '@/Routes.constants.ts';
import { useAtomValue } from 'jotai';
import { productsManagementFiltersAtom } from 'atoms/filters/products-management-filters.ts';
import { mapProductManagementFiltersToURLSearchParams } from '@/activityLog/productsManagement/Filters/utils/filtersToURLSearchParamsMapper.ts';

export const useProductsManagementUrlFromFilters = () => {
  const filters = useAtomValue(productsManagementFiltersAtom);

  return `${Routes.productsManagement}?${mapProductManagementFiltersToURLSearchParams(filters)}`;
};
